import { Injectable } from "@angular/core";
import { Title, Meta } from "@angular/platform-browser";
import { Settings } from "../app.settings";
import { ɵgetDOM as getDOM } from '@angular/platform-browser';

@Injectable()
export class SeoProvider {

    constructor(private titleProvider: Title, private metaProvider: Meta, private settings: Settings) {
    }

    public setTitle(newTitle: string) {
        this.titleProvider.setTitle(newTitle);
        this.metaProvider.updateTag({ property: 'og:title', newTitle });
    }

    public setMetaDescription(description: string) {
        this.metaProvider.updateTag({ name: 'description', content: description });
        this.metaProvider.updateTag({ property: 'og:description', content: description });
    }

    public setMetaKeywords(keywords: string) {
        this.metaProvider.updateTag({ name: 'keywords', content: keywords });
    }

    public setImage(image: string) {
        this.metaProvider.updateTag({ property: 'og:image', content: image });
    }

    public setType(type: string) {
        this.metaProvider.updateTag({ property: 'og:type', content: type });
    }

    public setUrl(url: string) {
        this.metaProvider.updateTag({ property: 'og:url', content: url });
    }

}